import type { Config } from './configType';

// Runtime config. On Azure (Kubernetes/nginx) a /config.js served before the app
// bundle sets window.__APP_CONFIG__ from the pod's ConfigMap (see Dockerfile +
// nginx/config.template.js), so one image serves every cluster. When that global
// is absent — `pnpm dev`, or the AWS S3/CloudFront build which ships no
// /config.js — we fall back to the build-time baked config (config.<CONFIG>.ts,
// selected by the CONFIG env var via the @/config-baked alias in vite.config.ts).
// This keeps the AWS path byte-for-byte unchanged while adding the Azure path.
import baked from '@/config-baked';

declare global {
  interface Window {
    __APP_CONFIG__?: Config;
  }
}

const config: Config =
  typeof window !== 'undefined' && window.__APP_CONFIG__ ? window.__APP_CONFIG__ : baked;

export { config };
export default config;
